import "core-js/modules/es.array.push.js";
import { defineComponent, onMounted, ref } from "vue";
import httpClient from "../request";
import { useRouter } from "vue-router";
import "element-plus/theme-chalk/index.css";
export default defineComponent({
  setup() {
    const router = useRouter();
    let showLogoutLink = ref(false); //标识是否显示“退出登录”按钮的变量
    const handleNodeClick = data => {
      if (data.isLeaf) {
        if (data.path == "overview") {
          router.push("/overview");
        } else {
          if (data.category == "leak") {
            router.push("/leakDashboard/" + data.path);
          } else {
            router.push("/corrosionDashboard/" + data.path);
          }
        }
      }
    };
    const leftTree = ref([]);
    const defaultProps = {
      children: "children",
      label: "label"
    };
    const newTree = [{
      id: "root",
      label: "大秦铁路",
      category: "not-sensor",
      children: [{
        id: "overview",
        label: "总览",
        isLeaf: true,
        path: "overview",
        category: "not-sensor"
      }, {
        id: "leak-current",
        label: "泄漏电流",
        isLeaf: false,
        category: "not-leaf",
        children: []
      }, {
        id: "contamination",
        label: "污秽",
        children: [],
        isLeaf: false,
        category: "not-sensor"
      }, {
        id: "air-corrosion",
        label: "大气腐蚀",
        children: [],
        isLeaf: false,
        category: "not-sensor"
      }],
      isLeaf: false
    }];
    //一次性把泄漏电流和大气腐蚀的传感器都加载进来
    let loadSensorList = () => {
      Promise.all([httpClient({
        url: "allSensors",
        params: {
          category: 'leak'
        },
        method: "get"
      }), httpClient({
        url: "allSensors",
        params: {
          category: 'corrosion'
        },
        method: "get"
      })]).then(([res1, res2]) => {
        //挂载泄漏电流传感器
        for (let index = 0; index < res1.data.length; index++) {
          const element = res1.data[index];
          newTree[0].children[1].children.push({
            //直接添加到newTree
            id: "leak-" + element.sensorNO,
            label: element.sensorNO,
            children: [],
            isLeaf: true,
            path: element.sensorNO,
            category: element.category
          });
        }
        //挂载大气腐蚀传感器
        for (let index = 0; index < res2.data.length; index++) {
          const element = res2.data[index];
          newTree[0].children[3].children.push({
            id: "corrosion-" + element.sensorNO,
            label: element.sensorNO,
            children: [],
            isLeaf: true,
            path: element.sensorNO,
            category: element.category
          });
        }
        leftTree.value = newTree;
      });
    };
    /**
     * 检查用户是否已经登录，以决定是否显示“退出登录”按钮
     */
    function checkLogin() {
      httpClient({
        url: "checkLogin",
        method: "get",
        withCredentials: true
      }).then(res => {
        showLogoutLink.value = res.data.hasLoggedIn;
      });
    }
    function logout() {
      httpClient({
        url: "logout",
        method: "get",
        withCredentials: true
      }).then(() => {
        router.push({
          name: "login"
        });
      });
    }
    onMounted(() => {
      checkLogin();
      loadSensorList();
    });
    let bgCSS = {
      height: "calc(100vh)",
      backgroundColor: "#0D1633",
      backgroundImage: `url('` + process.env.BASE_URL + `static/images/background.png')`
    };
    return {
      handleNodeClick,
      defaultProps,
      leftTree,
      bgCSS,
      showLogoutLink,
      logout
    };
  }
});